import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useSnackbar } from 'notistack';
// form
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { styled } from '@mui/material/styles';
import axios from 'axios';
import { paramCase } from 'change-case';
import 'react-phone-number-input/style.css';
// import ErrorSpan from '../verify-code/Error

import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
// @mui
// import { Stack } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

// hooks
import { Box, Button, Container, Typography, Stack } from '@mui/material';
import ErrorSpan from '../verify-code/ErrorSpan';
// import useIsMountedRef from '../../../hooks/useIsMountedRef';
// components

import { FormProvider, RHFTextField } from '../../../components/hook-form';
import Page from '../../../components/Page';
import LogoOnlyLayout from '../../../layouts/LogoOnlyLayout';
import { PATH_AUTH } from '../../../routes/paths';

MobileReset.propTypes = {
  onSent: PropTypes.func,
  onGetEmail: PropTypes.func,
};
const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));

// eslint-disable-next-line no-unused-vars
export default function MobileReset({ onSent, onGetEmail }) {
  const navigate = useNavigate();
  // const isMountedRef = useIsMountedRef();
  const { enqueueSnackbar } = useSnackbar();
  const [mobileno, setMobileno] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const ResetPasswordSchema = Yup.object().shape({
    mobileno: Yup.string().email('A phone number is required').required('Email is required'),
  });

  const defaultValues = {
    mobileno: '',
  };

  const methods = useForm({
    resolver: yupResolver(ResetPasswordSchema),
    defaultValues,
  });

  const {
    // handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const [nameError, setNameError] = useState({
    mobileno: null,
  });

  const onSubmit = async (data) => {
    if (!isValidPhoneNumber(mobileno)) {
      setNameError({ ...nameError, mobileno: 'Invalid Phone Number' });
      return;
    }

    const forgot = window.localStorage.setItem('getforget', 'forgot');
    window.localStorage.setItem('verifyscreen', 'mobileno');

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/web_register/verifying-identity`, {
        verify_field: mobileno,
      });

      const userId = response.data.user.id;

      if (response.status === 200) {
        enqueueSnackbar(response.data.message);
      }

      if (response.status === 200) {
        navigate(`${PATH_AUTH.verify}/${paramCase(userId.toString())}`);
      }

      if (response.error) {
        console.log('error');
      }
    } catch (e) {
     
      const error = e.response.data.error;
      if (error) {
        enqueueSnackbar(error, { variant: 'error' });
      }
    }
  };
  return (
    <Page title="Reset Password" sx={{ height: 1 }}>
      <RootStyle>
        <LogoOnlyLayout />
        <Container>
          <Box sx={{ maxWidth: 480, mx: 'auto' }}>
            <FormProvider
              methods={methods}
              onSubmit={(e) => {
                e.preventDefault();
                onSubmit(e.target);
                setSubmitted(true);
              }}
            >
              <Stack spacing={3}>
                <Typography variant="h3" paragraph>
                  Forgot your password?
                </Typography>
                <Typography sx={{ color: 'text.secondary', mb: 5 }}>
                  Please enter the mobile associated with your account and We will mobile you a link to reset your
                  password.
                </Typography>

                <PhoneInput
                defaultCountry='US'
                  id="public-phone"
                  style={{ border: submitted ? '1px solid #ff0000' : '1px solid #ddd' }}
                  placeholder="Enter Your Mobile No"
                  name="mobileno"
                  value={mobileno}
                  onChange={(e) => {
                    if (e !== undefined) {
                      try {
                        if (e?.length > 0) {
                          if (!isValidPhoneNumber(e)) {
                            setNameError({ ...nameError, mobileno: 'Invalid Phone Number' });
                          } else {
                            setMobileno(e.toString());

                            setNameError({ ...nameError, mobileno: null });
                          }
                        }
                      } catch (error) {
                        // setMobileno({ mobileno: "" });
                        // setNameError({ ...nameError, mobileno: null });
                      }
                    }
                  }}
                />

                {nameError.mobileno ? <ErrorSpan error={nameError.mobileno} /> : null}

                <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
                  Reset Password
                </LoadingButton>

                <Button fullWidth size="large" component={RouterLink} to={PATH_AUTH.resetPassword} sx={{ mt: 1 }}>
                  Back
                </Button>
              </Stack>
            </FormProvider>
          </Box>
        </Container>
      </RootStyle>
    </Page>
  );
}
